import { alpha } from "./utils/alpha";
export default {
  base: {
    50: "#F6F6F7",
    100: "#8199B1",
    200: "#5D7A98",
    300: "#36526D",
    400: "#283D52",
    500: "#1B2937",
    600: "#17222E",
    700: "#121C25",
    800: "#0C0E13",
    900: "#09080C",
    "50a": alpha("base.500", 0.04),
    "100a": alpha("base.500", 0.08),
    "200a": alpha("base.500", 0.16),
    "300a": alpha("base.500", 0.32),
    "400a": alpha("base.500", 0.64),
    "500a": alpha("base.500", 0.92),
  },
  primary: {
    50: "#ecfdff",
    100: "#cefaff",
    200: "#a3f1fe",
    300: "#64e5fc",
    400: "#1ed0f2",
    500: "#02c2eb",
    600: "#058eb5",
    700: "#0b7193",
    800: "#135c77",
    900: "#144d65",
    "50a": alpha("primary.500", 0.04),
    "100a": alpha("primary.500", 0.08),
    "200a": alpha("primary.500", 0.16),
    "300a": alpha("primary.500", 0.32),
    "400a": alpha("primary.500", 0.64),
    "500a": alpha("primary.500", 0.92),
  },
  secondary: {
    50: "#fffaeb",
    100: "#fef1c7",
    200: "#fde38a",
    300: "#fdce4c",
    400: "#fcb923",
    500: "#f69b13",
    600: "#da7105",
    700: "#b44e09",
    800: "#923c0e",
    900: "#78320f",
    "50a": alpha("secondary.500", 0.04),
    "100a": alpha("secondary.500", 0.08),
    "200a": alpha("secondary.500", 0.16),
    "300a": alpha("secondary.500", 0.32),
    "400a": alpha("secondary.500", 0.64),
    "500a": alpha("secondary.500", 0.92),
  }
};
